var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoMvpText = function SvgLogoMvpText(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115,
    height: 36,
    fill: "none",
    viewBox: "0 0 115 36",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E407B",
    d: "M83.466 35.25V.44h13.173c8.366 0 17.741 2.404 17.741 12.357 0 8.942-7.5 12.548-16.106 12.548h-.48v9.905zm14.327-18.751h.385c2.452 0 3.606-1.298 3.606-2.933s-1.202-2.933-3.606-2.933h-.385zM55.164 35.25 41.846.44h15.481l5.145 18.463h.096L68.048.44H82.04L68.722 35.25zM.453 35.25V.44h13.366l6.923 8.75L27.425.44h12.982v34.81H26.079V18.278h-.096L19.78 26.45l-6.347-8.173h-.096V35.25z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoMvpText);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo_mvp_text.c8934d6c3d42e847a1bf3a50a2c14b3e.svg";